// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__Rmtyx","header":"PatientBlock_header__3bGzL","label":"PatientBlock_label__3mbeT","option":"PatientBlock_option__1NyW0"};